<template>
  <component
    :is="itemComponent"
    :data="data"
    :placeholder="placeholder"
    :get-data="getData"
    @change="handleChange"
  />
</template>

<script>
import { getJoinTeamInfo, getAuthTeamInfo, getMyAuthTeamInfo } from '@/services/index'
import MyInput from './Input'
import MyCheckbox from './../formItem/CheckBox'
import InfotypeCheckbox from './InfoTypeCheckbox'
import SelectTree from './SelectTree'
import MyArea from './Area'
import CascaderGroup from './CascaderGroup'
import DateGroup from './DateGroup'
import InputGroup from './InputGroup'

export default {
  props: {
    'data': {
      type: [Object, Array, String, Boolean],
      default: () => { }
    }
  },
  data () {
    return {
      itemComponent: ''
    }
  },
  computed: {
    inquiryId () {
      return this.$route.params.inquiryId
    },
    from () {
      return this.$route.query.from || 'all'
    },
    type () {
      return this.$route.query.type || ''
    },
    routeName () {
      return this.$route.name
    },
    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldtype = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig
      let spaceStr = this.$isEnglish ? ' ' : ''

      if (fieldtype === 'text' || fieldtype === 'ip' || fieldtype === 'number' || fieldtype === 'phone' || fieldtype === 'email' || fieldtype === 'editor' || fieldtype === 'tag') {
        return placeholder || this.$t('message["751"]') + spaceStr + fieldname
      } else {
        return placeholder || this.$t('message["855"]') + spaceStr + fieldname
      }
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  watch: {
    data: {
      handler (val) {
        this.setItem()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
  },
  methods: {
    setItem () {
      let { fieldtype, fieldvalue = '' } = this.data || {}
      const { fieldconfig = {} } = this.data || {}
      const { info_sign: infoSign = {} } = fieldconfig
      let value = fieldvalue
      let beianValue = infoSign.fieldvalue || []

      switch (fieldtype) {
        case 'text':
          this.itemComponent = MyInput
          value = fieldvalue || ''
          break
        case 'number':
          this.itemComponent = InputGroup
          value = fieldvalue || {} // min max
          break
        case 'ip':
          this.itemComponent = MyInput
          value = fieldvalue || ''
          break
        case 'phone':
        case 'email':
          this.itemComponent = MyInput
          value = fieldvalue || []
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_followup':
        case 'checkbox':
          this.itemComponent = MyCheckbox
          value = fieldvalue || []
          break
        case 'radioinfo_type':
          this.itemComponent = InfotypeCheckbox
          value = fieldvalue || []
          if (this.data.fieldconfig && this.data.fieldconfig.info_sign) {
            this.$set(this.data.fieldconfig.info_sign, 'fieldvalue', beianValue)
          }
          break
        case 'selectrolegroup':
        case 'selectfollowuser':
        case 'selectinputuser':
        case 'selectuser':
          this.itemComponent = CascaderGroup
          if (fieldtype === 'selectfollowuser' || fieldtype === 'selectinputuser') {
            value = fieldvalue || {}
          } else {
            value = fieldvalue || [] // [{roleid, groupid, userid}]
          }

          break
        case 'from_info':
        case 'select_reception': // 接待方式
          this.itemComponent = CascaderGroup
          let { child, options } = this.data || {}
          this.data.options = options || child || []
          value = fieldvalue || []
          break
        case 'select_tree':
          this.itemComponent = SelectTree
          this.data.fieldconfig.enableinput = 0
          value = fieldvalue || {}
          break
        case 'timezones': // 时间区间
        case 'datetime':
        case 'followup_remind_time':
          this.itemComponent = DateGroup
          value = fieldvalue || {}
          break
        case 'area':
          this.itemComponent = MyArea
          this.data.fieldconfig.enableinput = 0
          this.data.fieldconfig.showSearch = 0
          value = fieldvalue || {}
          break
      }
      this.$set(this.data, 'isneeded', 0)
      this.$set(this.data, 'fieldvalue', value)
      this.$forceUpdate()
    },
    async getData (obj) {
      let { fieldkey = '', fieldtype } = obj
      let params = {}
      let result
      let key = fieldkey && fieldkey.split('_') && fieldkey.split('_')[0]
      if (key === 'follow-input' || key === 'follow') { key = 'followup' }
      if (key === 'input') { key = 'add' }

      if (this.from === 'all' && this.type.indexOf(key) !== -1) {
        params = { pk: `inquiry-${key}` }

        result = await getMyAuthTeamInfo()
          .params(params).fetch()
      } else if (fieldtype === 'selectrolegroup') { // 所属团队小组
        // params = { pk: 'inquiry-audit' }
        params = { pk: `inquiry-${key}` }

        if (this.type === 'inquiry-manager-share' || this.type === 'inquiry-manager-need-assign' || this.routeName === 'configListView') {
          params.type = 1
          result = await getAuthTeamInfo()
            .params(params).fetch()
        } else {
          result = await getJoinTeamInfo()
            .params(params).fetch()
        }
      } else {
        params = { pk: `inquiry-${key}` }

        result = await getAuthTeamInfo()
          .params(params).fetch()
      }

      const { payload: data = [] } = (result && result.data) || {}

      return data
    },

    handleChange (val) {
      this.data.fieldvalue = val
      this.$emit('change', val)
      this.$forceUpdate()
    }
  }
}
</script>
